import config from "../config";
import { concatOptionalParameter, sendGetRequest } from "../Utility/FetchUtils";
import DateUtil from "../Utility/DateUtil";
import { EventLog } from "../Model/EventLog";

class EventLogApi {
  static BASE_URL = config.SERVICE_URL + "/eventlog";

  static async getBetweenEventLog(
    startDate: Date | null,
    stopDate: Date | null
  ) {
    let url = EventLogApi.BASE_URL;

    url = concatOptionalParameter(url, {
      "start-from": startDate != null ? DateUtil.toString(startDate) : null,
      "stop-until": stopDate != null ? DateUtil.toString(stopDate) : null,
    });

    return sendGetRequest<EventLog[]>(url);
  }

  static async getImagingBetweenEventLog(
    startDate: Date | null,
    stopDate: Date | null
  ) {
    let url = EventLogApi.BASE_URL;

    url = concatOptionalParameter(url + "/imaging", {
      "start-from": startDate != null ? DateUtil.toString(startDate) : null,
      "stop-until": stopDate != null ? DateUtil.toString(stopDate) : null,
    });

    return sendGetRequest<EventLog[]>(url);
  }
}

export default EventLogApi;
